<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>MONITORING.TITLE</div>

</ion-header>

<ion-content class="ion-padding page2" no-bounce>

  <ng-template [ngIf]="isLoading">
    <div class="v-box full-width full-height justify-around align-center">
      <ion-spinner color="dark"></ion-spinner>
    </div>
  </ng-template>
  <ng-template [ngIf]="!isLoading">
          <h2 translate>MONITORING.SELF</h2>
      <ion-item>
        <ion-label translate>
          MONITORING.DIALOGS_LONG
        </ion-label>
        <ion-label slot="end">{{dialogStats.cntDiaUser}}</ion-label>
      </ion-item>  
      <ion-item>
        <ion-label translate>
          MONITORING.CONTENTS_LONG
        </ion-label>
        <ion-label slot="end">{{dialogStats.cntContUser}}</ion-label>
      </ion-item>  

      <h2 translate>MONITORING.GROUP</h2>
      <ion-item>
        <ion-label translate>
          MONITORING.DIALOGS_LONG
        </ion-label>
        <ion-label slot="end">&Oslash; {{calcRel(dialogStats.cntDiaGroup, dialogStats.cntGroup)}}</ion-label>
      </ion-item>  
      <ion-item>
        <ion-label translate>
          MONITORING.CONTENTS_LONG
        </ion-label>
        <ion-label slot="end">&Oslash; {{calcRel(dialogStats.cntContGroup, dialogStats.cntGroup)}}</ion-label>
      </ion-item>  

      <h2 translate>MONITORING.LEVEL.NAME</h2>
      <ion-item>
        <ion-label>
          {{levelName}}
        </ion-label>
      </ion-item>  
  </ng-template>


</ion-content>
